var exports = {
  "Sc": "Checkbox__l-SbhX",
  "EO": "Blankslate__7kchqW",
  "m4": "Octicon__9qFgvM",
  "az": "Box__M2i9OY",
  "wy": "Box_1__tf_9Mv",
  "pv": "Box_2__Lbhjdl",
  "w9": "Box_3__E6H1Ur",
  "EY": "Text__llAjpc",
  "UE": "Text_1__D2rb1a",
};

module.exports = exports;
